import {axiosService} from "../axios.service";
import {urls} from "../../constants";


const promoCodesService = {
    getAllPromoCodes: () => axiosService.get(urls.settings.promoCodes).then(value => value.data),
    createPromoCodes: (data) => axiosService.post(urls.settings.promoCodes, data).then((value) => value.data),
    updatePromoCodeById: (id, data) => axiosService.patch(`${urls.settings.promoCodes }/${id}`, data).then((value) => value.data),
    deletePromoCodeById: (id) => axiosService.destroy(`${urls.settings.promoCodes}/${id}`),
    deletePromoTableRuleById: (id) => axiosService.destroy(`/promo-codes/table-rule/${id}`),
};

export {
    promoCodesService
}